import { publisherShareInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import type { ShareUpdateRow } from './types'

const formatShare = (share: number | null | undefined): string => (share || share === 0 ? `${share}%` : '')

export const getPublisherRowId = (publisher: OriginalPublisherModel, index: number): string =>
    `${publisher.id ?? publisher.ipId ?? index}`

const parseShare = (share: string): number => Number(share.replace('%', ''))

export const publisherWithShare = (publisher: OriginalPublisherModel, share: string): OriginalPublisherModel => {
    const shareNumber = parseShare(share)
    const administrator = publisher.administratorPublishers[0]

    if (administrator) {
        return {
            ...publisher,
            administratorPublishers: [{ ...administrator, publisherShare: shareNumber }],
        }
    }

    return { ...publisher, publisherShare: shareNumber }
}

export const publisherToRow = (
    publisher: OriginalPublisherModel,
    index: number,
    existingPublisherCount: number
): ShareUpdateRow => {
    const administrator = publisher.administratorPublishers[0]
    const share = formatShare(administrator ? administrator.publisherShare : publisher.publisherShare)

    return {
        id: getPublisherRowId(publisher, index),
        publisherName: publisher.publisherName,
        administratorName: administrator?.publisherName ?? '',
        share,
        originalShare: share,
        editing: index >= existingPublisherCount,
        isNew: index >= existingPublisherCount,
    }
}

export const isValidShare = (share: string): boolean => {
    const parsedShare = parseShare(share)

    return !Number.isNaN(parsedShare) && !publisherShareInvalidCheck(parsedShare)
}
